import Vue from 'vue'
import StarRating from 'vue-star-rating'

Vue.use(StarRating)
